/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_jf_error_location = /** @type {(inputs: { line: NonNullable<unknown>, column: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`line ${i?.line}, column ${i?.column}`)
};

const es_jf_error_location = /** @type {(inputs: { line: NonNullable<unknown>, column: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`línea ${i?.line}, columna ${i?.column}`)
};

const de_jf_error_location = /** @type {(inputs: { line: NonNullable<unknown>, column: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zeile ${i?.line}, Spalte ${i?.column}`)
};

const nl_jf_error_location = /** @type {(inputs: { line: NonNullable<unknown>, column: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`regel ${i?.line}, kolom ${i?.column}`)
};

const fr_jf_error_location = /** @type {(inputs: { line: NonNullable<unknown>, column: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ligne ${i?.line}, colonne ${i?.column}`)
};

const it_jf_error_location = /** @type {(inputs: { line: NonNullable<unknown>, column: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`riga ${i?.line}, colonna ${i?.column}`)
};

const pt_br2_jf_error_location = /** @type {(inputs: { line: NonNullable<unknown>, column: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`linha ${i?.line}, coluna ${i?.column}`)
};

const pt_jf_error_location = /** @type {(inputs: { line: NonNullable<unknown>, column: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`linha ${i?.line}, coluna ${i?.column}`)
};

const ja_jf_error_location = /** @type {(inputs: { line: NonNullable<unknown>, column: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`行 ${i?.line}、列 ${i?.column}`)
};

const zh_jf_error_location = /** @type {(inputs: { line: NonNullable<unknown>, column: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`第 ${i?.line} 行，第 ${i?.column} 列`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ line: NonNullable<unknown>, column: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const jf_error_location = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.jf_error_location(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("jf_error_location", locale)
	if (locale === "en") return en_jf_error_location(inputs)
	if (locale === "es") return es_jf_error_location(inputs)
	if (locale === "de") return de_jf_error_location(inputs)
	if (locale === "nl") return nl_jf_error_location(inputs)
	if (locale === "fr") return fr_jf_error_location(inputs)
	if (locale === "it") return it_jf_error_location(inputs)
	if (locale === "pt-BR") return pt_br2_jf_error_location(inputs)
	if (locale === "pt") return pt_jf_error_location(inputs)
	if (locale === "ja") return ja_jf_error_location(inputs)
	return zh_jf_error_location(inputs)
};